import { render, staticRenderFns } from "./MassMessageConfirm.vue?vue&type=template&id=3d79a26a&"
import script from "./MassMessageConfirm.vue?vue&type=script&lang=ts&"
export * from "./MassMessageConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports